module.exports = __webpack_public_path__ + "static/media/hero-handle.79700e51.png";